export class L1Model {
  id: number = null;
  cod: string = null;
  description: string = null;


  constructor(id?: number, cod?: string, description?: string) {
    this.id = id;
    this.cod = cod;
    this.description = description;
  }
}
